import { observer } from "mobx-react-lite";
import { Box, Center, Image, Text } from "@chakra-ui/react";
import { Lang } from "@noli/core";

import { langStore, toolbarStore, translate, useSelecting } from "@noli/business";
import { Editor_Words } from "@/utils/lang/editor";
import Trigger from "@/components/Trigger";
import { themeStore } from "@/stores/theme";
import getScrollBarProps from "@/styles/scrollBarProps";

const IMAGE_LANG_MAP: Record<Lang, { url: string }> = {
  zh: {
    url: "https://localimage.oss-cn-hangzhou.aliyuncs.com/noli_creator_static/kbd_zh.jpeg?x-oss-process=image/resize,w_720",
  },
  en: {
    url: "https://localimage.oss-cn-hangzhou.aliyuncs.com/noli_creator_static/kbd_en.jpeg?x-oss-process=image/resize,w_720",
  },
};
function IntroPanel() {
  const lang = langStore.tgt;
  const { separatorColor } = themeStore.styles;
  const { type } = useSelecting("raw");

  if (type !== "none" || toolbarStore.inBrushMode) {
    return null;
  }

  return (
    <Center pt="24px" borderTop={`1px solid ${separatorColor}`}>
      <Trigger
        action={["click"]}
        placement="leftTop"
        offset={[-115, -258]}
        popup={
          <Box
            w={{ base: "300px", sm: "272px", md: "300px" }}
            rounded="8px"
            maxH={`calc(100vh - 116px)`}
            minH="150px"
            {...getScrollBarProps()}
            bg="rgb(24,30,39)"
            boxShadow="4px 4px 6px rgba(0, 0, 0, 0.25)"
          >
            <Image
              rounded="8px"
              src={IMAGE_LANG_MAP[lang].url}
              draggable={false}
              userSelect="none"
            />
          </Box>
        }
      >
        <Text color="brand.primary" fontSize="14px" cursor="pointer">
          {translate(Editor_Words["action-guide-and-shortcut"], lang)}
        </Text>
      </Trigger>
    </Center>
  );
}

export default observer(IntroPanel);
